import { useState } from 'react';
import { apiClient } from '../../utils/apiClient';
import Toast from '../shared/Toast';
import { useNavigate } from 'react-router-dom';
import log from '../shared/Logger';

const ForgotPassword = ({ onClose }) => {
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    email: '',
    isValidEmail: true,
    isLoading: false
  });

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+.[^\s@]+$/.test(email);

  const handleEmailChange = (e) => {
    setFormState((prev) => ({
      ...prev,
      email: e.target.value,
      isValidEmail: true
    }));
  };

  const handlePasswordReset = async () => {
    const { email } = formState;
    if (!validateEmail(email)) {
      setFormState((prev) => ({ ...prev, isValidEmail: false }));
      return;
    }

    setFormState((prev) => ({ ...prev, isLoading: true }));
    sessionStorage.setItem('forgetEmail', email);

    try {
      const response = await apiClient.auth.forgotPassword({ email });
      log(response, 'check the response');

      Toast.success('Password reset email sent successfully!');
      navigate('/forgot-password', { state: { email } });
    } catch (error) {
      Toast.error(JSON.parse(error.message).data.error || 'Password reset failed');
      console.error('Password reset failed:', error);
    } finally {
      setFormState((prev) => ({ ...prev, isLoading: false }));
    }
    onClose();
  };

  const { email, isValidEmail, isLoading } = formState;

  return (
    <>
      {/* Modal Header */}
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">Reset Your Password</h2>
        <p className="text-gray-600 mt-2">Enter your email to receive a reset link.</p>
      </div>

      {/* Email Input */}
      <div className="mt-4">
        <input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={handleEmailChange}
          className={`w-full px-4 py-3 border ${
            isValidEmail ? 'border-gray-300 focus:border-purple-500' : 'border-red-500'
          } rounded-md focus:ring-2 focus:ring-purple-500 outline-none transition-all duration-200`}
        />
        {!isValidEmail && <p className="mt-2 text-sm text-red-600">Please enter a valid email address</p>}
      </div>

      {/* Submit Button */}
      <button
        onClick={handlePasswordReset}
        disabled={isLoading}
        className="w-full mt-4 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-md transition-all duration-200 transform hover:scale-[1.02] focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        {isLoading ? (
          <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        ) : (
          'Send Reset Link'
        )}
      </button>
    </>
  );
};

export default ForgotPassword;
